<template>
  <footer class="footer">
    <div class="container-fluid">
      <div class="row">
        <div class="col-sm-6">
          {{ new Date().getFullYear() - 1 }} - {{ new Date().getFullYear() }} ©
          <a href="https://www.proset.gr/" target="_blank">Proset</a>.
          <p>Clock in Version: {{ version }}</p>
        </div>

        <div class="col-sm-6">
          <div class="text-sm-end d-none d-sm-block">
            Designed & Developed by
            <a href="https://www.proset.gr/" target="_blank">Proset</a>
          </div>
        </div>
      </div>
    </div>
  </footer>
  <!-- end footer -->
</template>

<script>
import { mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters("utils", ["getVersion"]),
    version() {
      return this.getVersion;
    },
  },
};
</script>
